import request from '@/utils/request';

export default {
    getItems: async({ dispatch, commit }, params) => {
        await request({ method: 'get', url: '/admin/reports', params })
            .then(res => {
                if (res.data) {
                    commit('PROCCESS_RES', res.data);
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    getUserReports: async({ dispatch, commit }, params) => {
        await request({ method: 'get', url: '/admin/reports/public/list', params })
            .then(res => {
                if (res.data) {
                    commit('SET_USER_REPORTS', res.data);
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    async getReportsCategories({commit, dispatch }, params) {
        await request({ method: 'get', url: '/admin/reports/categories', params })
            .then(res => {
                if (res.data) {
                    commit('SET_CATEGORIES', res.data);
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    getAllReports: async({ dispatch, commit }, params) => {
        await request({ method: 'get', url: '/admin/reports/all', params })
            .then(res => {
                if (res.data) {
                    commit('SET_ALL_REPORTS', res.data);
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    }
};
